










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BackSection extends Vue {
  data(){
    return {
      ...this.$store.state.customer
    }
  }
}
